<template>
	<el-card>
		<div slot="header" class="questionnaire header">
			<img src="../image/assessment.png" class="header-icon">
			<span class="header-title">Considerations</span>
		</div>
		<template v-if="recommendation && recommendation.length === 0">
			<div class="no-assessment-container">
				<img src="../image/no-assessment.png">
				<span class="no-assessment-header">Not enough data available to generate recommendation for the latest appointment</span>
			</div>
		</template>
		<template v-else>
			<div class="assessment-container">
				<el-tabs type="border-card" v-model="activeTab" :stretch="true" @tab-click="handleTabClick">
					<el-tab-pane name="history">
						 <span slot="label" class="header-label"> Key History</span>
						<div v-for="(item, index) in historyDetails" :key="index.id" class="item-container">
							<div class="item-heading">
								<img :src="require(`../image/${item.id}.svg`)" class="item-icon" /> {{ item.heading }}
								<span class="expander" ></span>
								<el-button type="info" size="mini" round plain @click="copyAllText(item.content)">
									<i class="el-icon-copy-document"></i>
									Copy
								</el-button>
							</div>
							<div v-for="(content, detailIndex) in item.content" :key="detailIndex" class="item-content">
								<p>{{ content.text }}</p>
								
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="Considerations" name="recommendation">
						<span slot="label" class="header-label"> Considerations</span>
						<div v-for="(item, index) in recommendationDetails" :key="index">
							<div class="item-heading">
								<img :src="require(`../image/${item.id}.svg`)" class="item-icon" /> {{ item.heading }}
							</div>
							<div v-for="(content, detailIndex) in item.content" :key="detailIndex" class="item-content">
								<div style="width:100%">
									<p v-html="content.text && content.text.replace(/\n/g, '<br/>')"></p>
									<div class="action-buttons" v-show="feedbackEnabled.includes(item.id)">
										<span class="thumbs-up-down">
											<i @click="handleThumbsUpClick(content.id)">
												<ThumbsUpIcon :active="feedbackDetails[content.id] && feedbackDetails[content.id] === 'positive'" :disabled="Object.values(recommendationLoadingIds).includes(true)" />
											</i>
											<i @click="handleThumbsDownClick(content.id)">
												<ThumbsDownIcon :active="feedbackDetails[content.id] && feedbackDetails[content.id] === 'negative'" :disabled="Object.values(recommendationLoadingIds).includes(true)" />
											</i>
											<span v-if="recommendationLoadingIds[content.id]">
												<LoadSpinner style="width: 20px; height: 20px;" type="primary" />
											</span>
										</span>
										<span class="additional-actions" v-if="feedbackDetails[content.id] && feedbackDetails[content.id] === 'negative'">
											<el-button type="danger" size="small" plain round @click="openCommentDialog(content.id)" :icon="metaMap[content.id] ? 'el-icon-finished' : 'el-icon-chat-line-square'">
												Feedback
											</el-button>
										</span>
									</div>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</template>
		<el-dialog :visible.sync="commentDialogVisible" title="Provide Feedback" width="50%" append-to-body class="message-dialog">
			<el-input type="textarea" v-model="commentText" placeholder="Enter your comments"></el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="commentDialogVisible = false">Cancel</el-button>
				<LoadingButton type="primary" @click="submitComment" :disabled="commentText.trim() === ''" :loading="commentSaving">Submit</LoadingButton>
			</div>
		</el-dialog>
	</el-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CopyMixin from '../chart/mixin/copy'
import formatDate from '@/module/util/format-date'
import ThumbsUpIcon from './ThumbsUp.vue'
import ThumbsDownIcon from './ThumbsDown.vue'
import LoadSpinner from '@/module/component/icon/LoadSpinner.vue'
import Vue from 'vue'

import OverviewCard from '..'
// import LoadingButton from '@/module/component/LoadingButton'

import QuestionnaireBucketMixin from '../mixin/questionnaire-bucket'
import copy from '../chart/mixin/copy'
import ThumbsUp from './ThumbsUp.vue'
import LoadingButton from '@/module/component/LoadingButton.vue'

export default {
	name: 'patient-assessment-card',
	extends: OverviewCard,

	mixins: [QuestionnaireBucketMixin, CopyMixin],

	data() {
		return {
			activeTab: 'history', // Default active tab
			recommendationLoadingIds: {},
			currentContentId: null,
			commentDialogVisible: false,
			commentText: '',
			commentSaving: false
		}
	},

	mounted() {
	},

	methods: {
		...mapActions('provider', [
			'pushNoteCategory',
			'updateEMREncounterNotes',
			'updatePatientRecommendationFeedback'
		]),
		formatDate,
		copyText(text) {
			this.copy(text)
		},
		copyAllText(contents) {
			const allText = contents.map(item => item.text).join('\n');
			this.copy(allText);
		},
		handleThumbsUpClick(contentId) {
			if(Object.values(this.recommendationLoadingIds).includes(true)) {
				return; // Prevent action if any recommendation is loading
			}
			let recommendation = this.recommendation[0]
			if (!recommendation) {
				console.error('No recommendation found for the patient');
				return;
			}
			let feedback = this.feedbackDetails
			// Toggle the feedback for the contentId
			if (feedback[contentId] === 'positive') {
				delete feedback[contentId]
			}
			else {
				feedback[contentId] = 'positive'
			}
			Vue.set(this.recommendationLoadingIds, contentId, true)
			this.updatePatientRecommendationFeedback({
				provider: recommendation.provider_id,
				patient: this.patient.id,
				recommendation: recommendation.id,
				feedback: {
					...feedback,
					meta: this.getRemovedMeta(contentId) // Get the meta without the comment for the contentId
				}
			}).then(() => {
				Vue.set(this.recommendationLoadingIds, contentId, false)
			}).catch(() => {
				Vue.set(this.recommendationLoadingIds, contentId, false)
			})
		},
		handleThumbsDownClick(contentId) {
			if(Object.values(this.recommendationLoadingIds).includes(true)) {
				return; // Prevent action if any recommendation is loading
			}
			let recommendation = this.recommendation[0]
			if (!recommendation) {
				console.error('No recommendation found for the patient');
				return;
			}
			let feedback = this.feedbackDetails
			// Toggle the feedback for the contentId
			if (feedback[contentId] === 'negative') {
				delete feedback[contentId]
			}
			else {
				feedback[contentId] = 'negative'
			}
			// Set the loading state for the contentId
			Vue.set(this.recommendationLoadingIds, contentId, true)
			// Update the feedback for the recommendation
			this.updatePatientRecommendationFeedback({
				provider: recommendation.provider_id,
				patient: this.patient.id,
				recommendation: recommendation.id,
				feedback: {
					...feedback,
					meta: this.getRemovedMeta(contentId) // Get the meta without the comment for the contentId
				}
			}).then(() => {
				Vue.set(this.recommendationLoadingIds, contentId, false)
			}).catch(() => {
				Vue.set(this.recommendationLoadingIds, contentId, false)
			})
		},
		openCommentDialog(contentId) {
			// Open the comment dialog for the specific contentId
			// Find the comment in meta if it exists
			const existingComment = (this.recommendation[0].meta || []).find(item => item.ref_id === contentId && item.type === 'comment');
			if (existingComment) {
				this.commentText = existingComment.text;
			} else {
				this.commentText = '';
			}
			this.commentDialogVisible = true
			this.currentContentId = contentId
		},
		submitComment() {
			const meta = (this.recommendation[0].meta || []).slice();
			let existingCommentIndex = meta.findIndex(item => item.ref_id === this.currentContentId && item.type === 'comment');
			if (existingCommentIndex !== -1) {
				Vue.set(meta, existingCommentIndex, {
					...meta[existingCommentIndex],
					text: this.commentText
				});
			} else {
				meta.push({
					ref_id: this.currentContentId,
					type: 'comment',
					text: this.commentText,
				});
			}

			this.commentSaving = true;
			this.updatePatientRecommendationFeedback({
				provider: this.recommendation[0].provider_id,
				patient: this.patient.id,
				recommendation: this.recommendation[0].id,
				feedback: {
					...this.feedbackDetails,
					meta: meta
				}
			}).then(() => {
				this.commentDialogVisible = false
				this.commentSaving = false;
				this.$message.success('Comment submitted successfully');
			}).catch(() => {
				this.$message.error('Failed to submit comment');
				this.commentDialogVisible = false;
				this.commentSaving = false;
			});
			
		},
		/**
		 * Get the meta array with comment removed for the given contentId
		 * This is used to get the comment text if it exists for the contentId
		 * @param {string} contentId - The ID of the content
		 * @return {Array} - The meta array with comment removed
		 */
		getRemovedMeta(contentId) {
			const meta = this.recommendation[0].meta || []
			return meta.filter(item => !(item.ref_id === contentId && item.type === 'comment'));
		},
		handleTabClick(tab) {
			try {
				const newRecommendation = this.recommendation;
				if (tab.name === 'recommendation' && newRecommendation && newRecommendation.length > 0) {
					const meta = newRecommendation[0].meta || [];
					const isConsideration = meta.some(item => item.type === 'activity' && item.ref_id === 'consideration');
					if(!isConsideration) {
						const newMeta = [...meta, {
							type: 'activity',
							ref_id: 'consideration',
							time: Date.now()
						}];
						this.updatePatientRecommendationFeedback({
							provider: newRecommendation[0].provider_id,
							patient: this.patient.id,
							recommendation: newRecommendation[0].id,
							feedback: {
								...(newRecommendation[0].feedback || {}),
								meta: newMeta
							}
						});
					}
				}
			} catch (error) {
				console.error('Error handling tab click:', error);
			}
			
		}
	},

	computed: {
		...mapGetters("provider", [
			"getPatient",
			"getPatientRecommendation"
		]),
		...mapGetters('content', [ 'getContent', 'getContentKey' ]),
		recommendation() {
			return this.getPatientRecommendation(this.patient.id) || []
		},
		feedbackEnabled() {
			return this.recommendation && this.recommendation.length > 0 && this.recommendation[0].feedback_enabled
		},
		historyDetails() {
			if(this.recommendation && this.recommendation.length > 0) {
				return this.recommendation[0].history || []
			}
			return []
		},
		recommendationDetails() {
			if (this.recommendation && this.recommendation.length > 0) {
				return this.recommendation[0].recommendation || []
			}
			return []
		},
		feedbackDetails() {
			if (this.recommendation && this.recommendation.length > 0) {
				return this.recommendation[0].feedback || {}
			}
			return {}
		},
		// Get meta data and convert to a map of key-value pairs key being ref_id and value being the text
		// This is used to display comments in the UI
		metaMap() {
			if (this.recommendation && this.recommendation.length > 0) {
				return (this.recommendation[0].meta || []).reduce((acc, item) => {
					if (item.type === 'comment') {
						acc[item.ref_id] = item.text;
					}
					return acc;
				}, {});
			}
			return {};
		},
	},


	components: {
		ThumbsUpIcon,
		ThumbsDownIcon,
		LoadSpinner,
		LoadingButton
	}
}
</script>

<style lang="scss" scoped>
	@import "../style.scss";
	.no-assessment-container {
		height: 100px;
		display: flex;
		justify-content: start;
		padding-left: 20px;
		align-items: center;
		img {
			width: 40px;
			height: 40px;
		}
		.no-assessment-header {
			margin: 15px;
			font-size: 14px;
			display: block;
			font-weight: 400;
			line-height: 17px;
			letter-spacing: 0.20000000298023224px;
			text-align: left;
		}
	}
	.assessment-container {
		margin-top: 20px;
		padding: 12px 16px;
		max-width: 900px;
		.is-active .header-label {
			font-weight: 600;
		}
		.header-label {
			font-size: 19px;
			line-height: 20px;
			color: #000000;
		}
		.item-heading {
			font-weight: 600;
			font-size: 18px;
			line-height: 20px;
			color: #000000;
			padding: 24px;
			display: flex;
			align-items: center;
			gap: 15px;
			display: flex;
			.expander {
				flex: 1;
			}
		}
		.item-content {
			padding: 24px;
			font-size: 16px;
			border-top: 1px solid #eee;
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 40px;
			p {
				line-height: 22px;
			}
		}
		.item-content:last-child {
			border-bottom: 8px solid #eee;
		}
	}
	.action-buttons {
		display: flex;
		margin-top: 10px;
		justify-content: space-between;
		span.thumbs-up-down {
			cursor: pointer;
			display: flex;
			gap: 24px;
			align-items: center;
			thumbs-up-icon, thumbs-down-icon {
				cursor: pointer;
				width: 24px;
				height: 24px;
			}
		}
	}
</style>

<style lang="scss" >
	.assessment-container {
		.el-tabs__content {
			padding: 0 !important;
			padding-top: 30px !important;
		}
	}
</style>